import { BaseApi } from "../base";

export default class VideoApi extends BaseApi {
  protected readonly service = "video";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  uploadScreencast = (data: FormData) => this.post("screencasts", data);
}
